import React from 'react';
import { BarChart,Bar, XAxis, YAxis, CartesianGrid, Tooltip, Label, 
    LabelList, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import { setCurrencyFormatInWon, setCurrencyFormat } from '../../../../utils/helpers';

const RevanueForYearlyChart = ({ dir, height, dataToPlot, index, currency }) => {
    const thisMonthData = {};
    return (        
        <ResponsiveContainer width="100%" height={height} style={{ marginTop: '50px' }}>
                    <BarChart
                        width={500}
                        height={400}
                        data={dataToPlot}
                        margin={{
                            top: 25,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                        <XAxis dataKey="year" reversed={dir === 'rtl'} />
                        <YAxis yAxisId="left" type="number" allowDataOverflow 
                        tickFormatter={value => currency === 'Won' ? 
                        setCurrencyFormatInWon(Number(value).toFixed(0), true) : 
                        setCurrencyFormat(Number(value).toFixed(0), true)}
                        width={120}
                        tick
                        >
                        {/* <Label angle={-90} value="Amount"
                        position='insideLeft' style={{ textAnchor: 'middle' }} /> */}
                        </YAxis>               
                        <Tooltip formatter={value => currency === 'Won' ? 
                        setCurrencyFormatInWon(Number(value).toFixed(2), true) : 
                        setCurrencyFormat(Number(value).toFixed(2), true)} />
                        <Legend />
                        <Bar
                                            stackId="count"
                                            yAxisId="left"
                                            // fill={color1}
                                            fill="#66CDAA"
                                            dataKey={"Amount"?.toString()}
                                            stroke="#000000"
                                            barSize={100}
                                        >
                        <LabelList dataKey="Amount" 
                        formatter={value => currency === 'Won' ? 
                        setCurrencyFormatInWon(Number(value).toFixed(2), true) : 
                        setCurrencyFormat(Number(value).toFixed(2), true)} position="top" /></Bar>
                    </BarChart>
                </ResponsiveContainer>
    )
}

RevanueForYearlyChart.propTypes = {
    dir: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    dataToPlot: PropTypes.arrayOf({}).isRequired,
    index: PropTypes.number,
    currency: PropTypes.string
    // eslint-disable-next-line react/forbid-prop-types
};

RevanueForYearlyChart.defaultProps = {
    index: 0,
    currency: 'Won'
  }

export default React.memo(RevanueForYearlyChart);